import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { baseHeaders } from 'util/axios-request';
import { utilCookies } from '@/util/cookies';
var baseURL = process.env.VUE_APP_BASE_API;
export default {
  props: {
    subProjectId: String,
    fileSize: {
      type: Number,
      default: 5
    }
  },
  data: function data() {
    return {
      title: '',
      data: [],
      item: {},
      visible: false,
      activeName: '1',
      multiple: true,
      fileFormat: ['.xls', '.xlsx'],
      baseHeaders: baseHeaders(),
      // fileSize: 5,
      uploadHeaders: {},
      successFileList: [],
      uploadTotalCount: 0,
      // 总数
      uploadSuccessCount: 0,
      // 成功数
      uploadFailCount: 0,
      // 失败数
      update_count: 0,
      feedbackFileUrl: '',
      form: {
        name: ''
      },
      formData: {}
    };
  },
  computed: {
    uploadUrl: function uploadUrl() {
      return baseURL + this.item.upload_api;
    }
  },
  methods: {
    init: function init(data) {
      this.title = data.title;
      this.data = data.list;
      this.item = this.data[this.activeName];
      this.formData = this.item.query;
      this.visible = true;
    },
    handleClick: function handleClick() {
      this.item = this.data[this.activeName];
    },
    handleExport: function handleExport() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, lang, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 模版下载
              data = _this.item || {};
              if (data.download_api) {
                data.download_api(data.query).then(function (res) {
                  var url = res.data.url || res.data;
                  window.open(url);
                });
              } else {
                lang = utilCookies.getLanguage() && utilCookies.getLanguage().substring(0, 2) || 'th';
                res = data[lang] || '';
                window.open(res);
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    beforeUploadHandle: function beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        var fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(this.$t('729', {
            fileFormat: this.fileFormat.join()
          }));
          return false;
        }
      } else {
        // this.listType = "text";
      }

      // 文件大小
      if (!(file.size / 1024 / 1024 < this.fileSize)) {
        this.$message.error(this.$t('730', {
          fileSize: this.fileSize
        }));
        return false;
      }
    },
    // 上传成功+
    successHandle: function successHandle(res, file) {
      var data = res.data;
      if (res && res.code === 1) {
        this.$set(this.item, 'uploadStatus', true);
        this.$set(this.item, 'uploadResultState', data.upload_result_state || 0); // 1.全部成功 3，全部失败，5部分成功
        this.$set(this.item, 'uploadSuccessCount', data.upload_success_count || 0); // 成功数
        this.$set(this.item, 'uploadFailCount', data.upload_fail_count || 0); // 失败数
        this.$set(this.item, 'update_count', data.upload_total_count || 0); // 覆盖数
        this.$set(this.item, 'uploadTotalCount', data.upload_total_count || 0); // 总数
        this.$set(this.item, 'feedbackFileUrl', data.file_path);
        if (data.list) this.$set(this.item, 'list', data.list || []);
        if (data.columns) this.$set(this.item, 'columns', data.columns || {});
        if (data.status_map) this.$set(this.item, 'status_map', data.status_map || []);
      }
    },
    doSubmit: function doSubmit() {
      if (this.item.emit) {
        if (this.item.list) {
          this.$emit('doSubmit', {
            result_state: this.item.uploadResultState,
            list: this.item.list || [],
            status_map: this.item.status_map || [],
            columns: this.item.columns || {}
          });
        } else {
          this.$emit('doSubmit');
        }
      }
      this.visible = false;
    },
    handleOpenUrl: function handleOpenUrl(url) {
      window.open(url);
    },
    // 上传失败
    // err, file, fileList
    errorHandle: function errorHandle(err, file) {
      var index = this.$refs.upload.uploadFiles.findIndex(function (v) {
        return v.name === file.name;
      });
      this.$refs.upload.uploadFiles.splice(index, 1);
      var msg = JSON.parse(err['message']);
      this.$message.error(msg.message);
      throw err;
    },
    resetDate: function resetDate() {
      this.$set(this.item, 'uploadStatus', false);
      this.$set(this.item, 'uploadSuccessCount', 0); // 成功数
      this.$set(this.item, 'uploadFailCount', 0); // 失败数
      this.$set(this.item, 'update_count', 0); // 覆盖数
      this.$set(this.item, 'uploadTotalCount', 0); // 总数
      this.$set(this.item, 'feedbackFileUrl', '');
    },
    // 弹窗关闭时
    closeHandle: function closeHandle() {
      this.reset();
      this.resetDate();
    },
    reset: function reset() {
      this.$refs.upload.clearFiles();
      this.successFileList = [];
    }
  },
  watch: {
    successFileList: {
      handler: function handler(val) {
        if (val.length) this.$emit('uploadSuccess', val);
      },
      deep: true
    }
  }
};